module.exports = __webpack_public_path__ + "img/menu-trial.0e609d0e.png";